import React, { FC, useEffect } from 'react';
import { Layout, LayoutProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '~/Store/hooks';
import { LayoutActions } from '~/Store/Layout';

import styles from './Page.module.less';

const { Content } = Layout;

interface PageProps {
  title?: string;
}

export const Page: FC<LayoutProps & PageProps> = ({
  children,
  title,
  className,
  ...props
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  
  useEffect(() => {
    if (title) {
      // Kiểm tra nếu title có dạng translation key (có dấu chấm) thì dịch, không thì giữ nguyên
      const translatedTitle = title.includes('.') ? t(title) : title;
      dispatch(LayoutActions.setDocumentTitle(translatedTitle));
    }
  }, [title, t, dispatch]);

  return (
    <Layout className={`${styles.Page} ${className}`} {...props}>
      <Content className={styles.Content}>
        {children}
      </Content>
    </Layout>
  );
};